const serviceData1 = [
    {
        img: "https://via.placeholder.com/800x618",
        name: 'NGOs name',
        icon: "fas fa-arrow-right",
        title: "FINANCE SERVICES",
        content: "Lorem ipsum consectetur adipiscing elit do eiusmod tempor incididunt.",
        link: "/page/our-story"
    },
    {
        img: "https://via.placeholder.com/800x618",
        icon: "fas fa-arrow-right",
        name: 'NGOs name',

        title: "BUSINESS PLANNING",
        content: "Lorem ipsum consectetur adipiscing elit do eiusmod tempor incididunt.",
        link: "/page/our-story"
    },
    {
        img: "https://via.placeholder.com/800x618",
        icon: "fas fa-arrow-right",
        title: "MARKETING STRATEGY",
        content: "Lorem ipsum consectetur adipiscing elit do eiusmod tempor incididunt.",
        link: "/page/our-story"
    }
]
const serviceData2 = [
    {
        img: "https://via.placeholder.com/800x618",
        icon: "fas fa-arrow-right",
        name: 'Samerth Charitable Trust',

        title: "FINANCE SERVICES",
        content: "Lorem ipsum consectetur adipiscing elit do eiusmod tempor incididunt.",
        link: "/page/our-story"
    },
    {
        img: "https://via.placeholder.com/800x618",
        icon: "fas fa-arrow-right",
        name: 'Etasha',

        title: "BUSINESS PLANNING",
        content: "Lorem ipsum consectetur adipiscing elit do eiusmod tempor incididunt.",
        link: "/page/our-story"
    },
    {
        img: "https://via.placeholder.com/800x618",
        icon: "fas fa-arrow-right",
        name: 'Thane CPCA',
        title: "MARKETING STRATEGY",
        content: "Lorem ipsum consectetur adipiscing elit do eiusmod tempor incididunt.",
        link: "/page/our-story"
    }
]



export { serviceData1, serviceData2 }